import { Divider } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Button, FormControl, MenuItem, Select, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import { defaultApplicantsData } from "../../../_utilities/defaultfieldsModel";
import GetJobId from "../../../_utilities/GetJobId";
import { GetTimeZone } from "../../../_utilities/GetTimeZone";
import { getCandidateStatusId } from "../../../_utilities/internalexternalhelper";
import AssociateCards from "../../../components/AssociateCards/AssociateCards";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import { UpdateStausillus } from "../../../Icons/UpdateStausillus";

import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import * as _props from "../../../_redux/_services/JobPostingSlice";
import ApplicantsFooter from "../../../components/ApplicantsFooter/ApplicantsFooter";
import "./ApplicantAssociatedJobs.css";

import {
  getAttributes,
  GetUserId,
  GetUserInfo,
} from "../../../_utilities/getUserInfo";
const initalState = { data: null, message: "", isloader: true };

const AddApplicantAssociatedJobs = ({
  componentType,
  isRightSidePannel,
  AccociatedJobSeekerList,
  onPropsReceive,
  questionsData,
  getData,
  pannelobj,
  isAssociate = null,
  isBulk = false,
}) => {
  const getJobCode = GetJobId();

  return (
    <div
      className={
        componentType === "jobProfile" ? "jobProfileWidth" : "rightsidebarbtn"
      }
    >
      <RightSideBar
        componentData={
          <ComponentRenderData
            JobId={getJobCode}
            isLoad={isRightSidePannel}
            clientData={AccociatedJobSeekerList}
            componentType={componentType}
            onReceivechildProps={onPropsReceive}
            questionsData={questionsData}
            getData={getData}
            isAssociate={isAssociate}
            isBulk={isBulk}
          />
        }
        componentLayout={
          componentType === "AssociatedJobs"
            ? ASAObj
            : componentType === "Questions&Answers"
              ? QAObj
              : componentType === "jobProfile"
                ? pannelobj
                : ""
        }
        isFooter={false}
        footerImg={
          componentType === "AssociatedJobs" ? (
            <UpdateStausillus />
          ) : componentType === "Questions&Answers" ? (
            <UpdateStausillus />
          ) : componentType === "jobProfile" ? (
            <UpdateStausillus />
          ) : (
            ""
          )
        }
        onReceiveProps={onPropsReceive}
      />
    </div>
  );
};

const ComponentRenderData = ({
  JobId,
  clientData,
  onReceivechildProps,
  isLoad,
  componentType,
  questionsData,
  getData,
  isAssociate,
  isBulk,
}) => {
  const [jobData, setjobData] = useState(null);
  const [value, setValue] = React.useState("1");
  const [documents, setDocuments] = useState([]);
  const [AlljobData, setAlljobData] = useState([]);
  const [managerObj, setManagerObj] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [teamLeadObj, setteamLeadObj] = useState([]);
  const [updateStatus, setUpdateStatus] = useState("");
  const [totalRecords, setTotalRecords] = useState(null);
  const [findconfig, setFindconfig] = useState(findconfiguration);
  const [jobPostingsDetails, setJobPostingsDetails] = useState({});
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);
  const [linkNewApplicantToJobDetails, setIinkNewApplicantToJobDetails] =
    useState([]);

  const dispatch = useDispatch();
  const getJobCode = GetJobId();

  // reducer data
  const getDetails = useSelector((state) => state.Jobpostingsbyid.data);
  const GetDocumentsdata = useSelector((state) => state.GetDocuments.data);
  const managerList = useSelector((state) => state.GetManagerTeamlead.manager);
  const teamleadList = useSelector(
    (state) => state.GetManagerTeamlead.teamLeads,
  );
  const AddAssociatedjobscode = useSelector(
    (state) => state.AddAssociatedjobs.data,
  );
  const updateCandidateCode = useSelector(
    (state) => state.UpdateCandidateStatus.data,
  );
  const DelAssociatedjobscode = useSelector(
    (state) => state.DeleteAssociatedjobs.data,
  );
  const GetMatchAssociatedJobsData = useSelector(
    (state) => state.GetMatchAssociatedJobs.data,
  );

  useEffect(() => {
    if (getData) {
      dispatch(_props.jobpostingsbyidAsync(getData.jobopeningID));
    }
  }, [getData]);

  useEffect(() => {
    if (componentType === "jobProfile") {
      const init = async () => {
        const userId = await GetUserId();
        dispatch(_props.getManagerTeamleadAsync("team Lead", userId));
        dispatch(_props.getManagerTeamleadAsync("manager", userId));
      };
      init();
    }
  }, []);

  useEffect(() => {
    if (
      getDetails !== null &&
      getDetails !== undefined &&
      managerList &&
      teamleadList
    ) {
      let postingData = JSON.parse(JSON.stringify(getDetails));
      let managerIndex = managerList?.findIndex(
        (x) => x.id === postingData.manager,
      );
      if (managerIndex !== -1) {
        postingData.managerName =
          managerList[managerIndex].firstName +
          " " +
          managerList[managerIndex].lastName;
      } else {
        postingData.managerName = "";
      }
      let teamLeadIndex = teamleadList?.findIndex(
        (x) => x.id === postingData.teamLead,
      );
      if (teamLeadIndex !== -1) {
        postingData.teamLeadname =
          teamleadList[teamLeadIndex].firstName +
          " " +
          teamleadList[teamLeadIndex].lastName;
      } else {
        postingData.teamLeadname = "";
      }
      let jobType = postingData.jobType.split(",");
      postingData.jobType = jobType.join(", ");
      setJobPostingsDetails(postingData);
      dispatch(_props.jobpostingsbyidStartReducer(initalState));
    }
  }, [getDetails, teamleadList, managerList]);

  useEffect(() => {
    if (teamleadList && teamleadList.length > 0) {
      const data = JSON.parse(JSON.stringify(teamleadList));
      setteamLeadObj(data);
      dispatch(_props.getManagerTeamleadStartReducer({}));
    }
  }, [teamleadList]);

  useEffect(() => {
    if (managerList && managerList.length > 0) {
      const data = JSON.parse(JSON.stringify(managerList));
      setManagerObj(data);
      dispatch(_props.getManagerTeamleadStartReducer({}));
    }
  }, [managerList]);

  useEffect(() => {
    if (clientData.length > 0) {
      let selectedIdsArray = [];
      clientData?.map((x) => {
        let obj = {
          id: x.jobopeningID,
          documentName: x.documentName,
          lastUpdated: x.docCreatedDate,
          uploadedBy: x.docUploadedBy,
          docId: x.docId,
        };
        selectedIdsArray.push(obj);
      });
      setSelectedIds(selectedIdsArray);
    }
  }, [clientData, AlljobData]);

  const GetData = async () => {
    dispatch(_ser.getMatchAssociatedJobsAsync(JobId));
  };

  useEffect(() => {
    if (
      GetMatchAssociatedJobsData !== null &&
      GetMatchAssociatedJobsData !== undefined
    ) {
      setjobData(null);
      if (GetMatchAssociatedJobsData.length > 0) {
        let myData = JSON.parse(JSON.stringify(GetMatchAssociatedJobsData));
        setTimeout(() => {
          setjobData(myData);
        }, 200);
        dispatch(_ser.getMatchAssociatedJobsStartReducer(initalState));
      }
    }
  }, [GetMatchAssociatedJobsData]);

  const onActionHandler = (id, type) => {
    if (type === "delete") {
      DeleteAssociatedjobs(id);
    } else if (type === "add") {
      AddAssociatedjobs(id);
      setSearchValue({ keyword: id.keyword });
    } else if (type === "searchResult") {
      setSearchValue(id);
      getListJobs(id);
      FetchDoc(id);
    } else if (type === "linkNewApplicantToJob") {
      let selectedJobs = [...selectedIds];
      let jobIdIndex = selectedJobs.findIndex((x) => x.id === id?.id);
      let jobDetailsIndex = linkNewApplicantToJobDetails.findIndex(
        (x) => x.id === id?.id,
      );
      if (jobIdIndex !== -1) {
        selectedJobs.splice(jobIdIndex, 1);
        if (jobDetailsIndex !== -1) {
          linkNewApplicantToJobDetails.splice(jobDetailsIndex, 1);
          setIinkNewApplicantToJobDetails([...linkNewApplicantToJobDetails]);
        }
      } else {
        if (isBulk === true && selectedJobs.length > 0) {
          dispatch(
            updateSnackbar({
              type: "error",
              message: "Only single Job selection is allowed",
            }),
          );
        } else {
          setIinkNewApplicantToJobDetails((prev) => [...prev, id]);
          selectedJobs.push({
            id: id?.id,
            jobCode: id?.jobCode,
            title: id?.jobTitle,
          });
        }
      }
      setSelectedIds(selectedJobs);
    }
  };

  const DeleteAssociatedjobs = async (obj) => {
    obj["portalassociatedJobs"] = "associatedJobs";
    dispatch(_ser.deleteAssociatedjobsAsync(JobId, obj));
  };

  useEffect(() => {
    if (DelAssociatedjobscode === 200) {
      onReceivechildProps(true, "getFetch");
      dispatch(_ser.deleteAssociatedjobsStartReducer(initalState));
    }
  }, [DelAssociatedjobscode]);

  useEffect(() => {
    FetchDoc();
  }, []);

  const FetchDoc = async () => {
    setDocuments([]);
    dispatch(_ser.getDocumentsAsync(getJobCode));
  };

  useEffect(() => {
    if (GetDocumentsdata !== null) {
      let docData = JSON.parse(JSON.stringify(GetDocumentsdata));
      if (docData.length > 0) {
        docData.forEach((list) => {
          list.date = GetTimeZone(list.date);
          list["total_count"] = docData.length;
          list["uploadedBy"] = list.firstName + " " + list.lastName;
          list["docscreatedDate"] = list.createdDate;
        });
        let resumeData = docData.filter((x) => x.documentType === "Resume");
        setDocuments(resumeData.reverse());
        dispatch(_ser.getDocumentsStartReducer(initalState));
      } else {
        setDocuments([]);
      }
    }
  }, [GetDocumentsdata]);

  const AddAssociatedjobs = async (obj) => {
    let userInfo = await GetUserInfo();
    let userId = await getAttributes();
    obj["portalassociatedJobs"] = "associatedJobs";
    obj["status"] = "Associated";
    obj["source"] = "ATS";
    obj["submittedBy"] = userInfo[0].id;
    obj["firstName"] = userId[0].firstName;
    obj["lastName"] = userId[0].lastName;
    obj["jobs"] = [{ jobId: obj.id, jobCode: obj.jobCode }];
    obj.id = JobId;
    dispatch(_ser.addAssociatedjobsAsync(JobId, obj, "posting"));
  };

  useEffect(() => {
    if (AddAssociatedjobscode === 200) {
      onReceivechildProps(true, "getFetch");
      dispatch(_ser.addAssociatedjobsStartReducer(initalState));
    }
  }, [AddAssociatedjobscode]);

  useEffect(() => {
    if (JobId && isLoad === true) {
      GetData();
    }
    let obj = { currentPage: 1, keyword: "", limit: 9, offset: 1 };
    dispatch(_props.listjobpostingsAsync(obj, "searchWithPaging"));
    // eslint-disable-next-line
  }, [JobId, isLoad]);

  const responseData = useSelector((state) => state.Listjobpostings.data);

  const getListJobs = async (obj) => {
    setAlljobData([]);
    if (obj.keyword) {
      dispatch(_props.listjobpostingsAsync(obj, "searchWithoutPaging"));
    } else {
      dispatch(_props.listjobpostingsAsync(obj, "searchWithPaging"));
    }
  };

  const handleChange = (event, Value) => {
    setValue(Value);
    setAlljobData([]);
  };

  useEffect(() => {
    if (responseData && responseData?.rows?.length > 0) {
      setAlljobData(responseData.rows);
      setFindconfig({ ...findconfig, totalRecords: responseData.total_count });
      setTotalRecords(responseData.total_count);
      setSearchValue("");
      dispatch(_props.listjobpostingsStartReducer(initalState));
    } else if (responseData?.rows?.length === 0) {
      setAlljobData([]);
    }
  }, [responseData]);

  const onChangeHandler = (value, type) => {
    if (type === "candidateStatus") {
      setUpdateStatus(value);
    }
  };

  const HandleSubmit = async (event) => {
    if (updateStatus !== "") {
      const url = window.location.pathname;
      const path = url.substring(url.lastIndexOf("/") + 1);
      let jobId = getJobCode;
      const statusId = getCandidateStatusId(
        updateStatus,
        candidateStatusValues,
      );
      let updateData = {
        data: [
          {
            id: getData.asscoId.toString(),
            status: statusId,
            applicantId: path,
            jobCode: jobPostingsDetails.jobCode,
          },
        ],
      };
      dispatch(_props.updateCandidateStatusAsync(jobId, updateData));
    } else {
      dispatch(updateSnackbar({ type: "error", message: "Change status" }));
    }
  };

  useEffect(() => {
    if (updateCandidateCode === 200) {
      dispatch(_props.updateCandidateStatusStartReducer(initalState));
      onReceivechildProps(false, "getFetch");
    }
  }, [updateCandidateCode]);

  useEffect(() => {
    let defaultPostingModules = defaultApplicantsData.filter(
      (x) => x.moduleId === "2",
    );
    if (defaultPostingModules.length > 0) {
      defaultPostingModules.forEach((list) => {
        if (list.fieldName === "Candidate status") {
          setCandidateStatusValues(list.customValues);
        }
      });
    }
  }, []);

  const customFieldsData = useSelector((state) => state.CustomFields.data);

  useEffect(() => {
    async function init() {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let customStatusFieldsData = data.filter(
        (x) =>
          x.moduleId.toString() === "2" &&
          x.fieldType === "default" &&
          x.fieldName === "Candidate status",
      );
      if (customStatusFieldsData.length > 0) {
        let index = customStatusFieldsData.length - 1;
        let array = JSON.parse(customStatusFieldsData[index].customValues);
        setCandidateStatusValues(array);
      }
    }
  }, [customFieldsData]);

  const footerHandler = (id, type) => {
    if (type === "removeJob") {
      onActionHandler(id, "linkNewApplicantToJob");
    }
    if (type === "Save") {
      if (linkNewApplicantToJobDetails.length !== 0) {
        dispatch(
          _ser.setSelectedJobDetailsReducer(linkNewApplicantToJobDetails),
        );
        onReceivechildProps(false, { type: "associateJobSave", data: null });
      } else {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please select at least one Job",
          }),
        );
      }
    } else if (type === "Back") {
      onReceivechildProps(false, "Back");
    }
  };

  return (
    <>
      {componentType === "AssociatedJobs" && (
        <div className="tabs">
          <Box
            sx={{
              width: "100%",
              typography: "body1",
              color: "#3B4046",
              marginTop: "-35px",
            }}
          >
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  className="tabsvalue"
                >
                  <Tab label="Find jobs" value="1" />
                </TabList>
              </Box>
              <TabPanel value="1">
                <div className="mt-5">
                  {AlljobData ? (
                    <AssociateCards
                      documentData={documents}
                      data={AlljobData}
                      isAImatched={false}
                      selectedItems={selectedIds}
                      searchKeyWord="Search by Job code, Job Title"
                      navigateTo="/ats/layout/jobpostings/view/"
                      config={findconfig}
                      componentType="AssociatedJobs"
                      isAssociate={isAssociate}
                      onReceiveHandler={(Item, obj) =>
                        onActionHandler(Item, obj)
                      }
                    />
                  ) : (
                    <div>
                      <div className="nodatasection nodataSection">
                        <img
                          src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                          alt="noResult"
                        />
                        No Jobs
                      </div>
                    </div>
                  )}
                </div>
                {isAssociate === false && ( // && linkNewApplicantToJobDetails
                  // <div style={{textAlign:"right",marginTop:"3%"}}>
                  //     <Button
                  //         variant="text"
                  //         type="button"
                  //         className="addApplicantcancelBtn"
                  //         onClick={() => {
                  //           dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));
                  //           onReceivechildProps(false, "linkNewApplicantToJob");
                  //         }}
                  //         size="small"
                  //     >
                  //         <Link href="#" style={{color:"red", fontSize:"14px"}} underline="always"> Cancel</Link>
                  //     </Button>
                  //     <Button type="button" variant="contained" size="small" className="saveBtn"
                  //         onClick={() => {
                  //           dispatch(_ser.setSelectedJobDetailsReducer(linkNewApplicantToJobDetails))
                  //           onReceivechildProps(false, "associateJobSave");
                  //         }}>
                  //         Save
                  //     </Button>
                  // </div>
                  <div className="footer_btn">
                    <ApplicantsFooter
                      onReceiveProps={footerHandler}
                      isEnableAssociateJob={false}
                      selectedItems={selectedIds}
                      component={"associateJob"}
                    />
                  </div>
                )}
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      )}
      {componentType === "Questions&Answers" && (
        <div style={{ height: "calc(100vh - 459px)", overflowY: "auto" }}>
          {questionsData.length > 0 &&
            questionsData.map((item) => {
              return (
                <div className="questionsarea">
                  <h3>{item.question}</h3>
                  <p>{item.answer.join(", ")}</p>
                </div>
              );
            })}
        </div>
      )}
      {componentType === "jobProfile" && (
        <div>
          <div className="jobsdatacss">
            <tr>
              <td>Job Type</td>
              <td>:</td>
              <td>{jobPostingsDetails?.jobType}</td>
            </tr>
            <tr>
              <td>External Job ID</td>
              <td>:</td>
              <td>{jobPostingsDetails.externalSystemID}</td>
            </tr>
            <tr>
              <td>Job Status</td>
              <td>:</td>
              <td>{jobPostingsDetails.jobStatus}</td>
            </tr>
            <tr>
              <td>Client</td>
              <td>:</td>
              <td>{jobPostingsDetails.clientName}</td>
            </tr>
            <tr>
              <td>Client Bill Rate</td>
              <td>:</td>
              <td>{jobPostingsDetails.clientBillRate}</td>
            </tr>
            <tr>
              <td>Pay rate/Salary</td>
              <td>:</td>
              <td>{jobPostingsDetails.payBillRate}</td>
            </tr>
            <tr>
              <td>Location</td>
              <td>:</td>
              <td>{jobPostingsDetails.location}</td>
            </tr>
            <tr>
              <td>Manager</td>
              <td>:</td>
              <td>{jobPostingsDetails.managerName}</td>
            </tr>
            <tr>
              <td>Team Lead</td>
              <td>:</td>
              <td>{jobPostingsDetails.teamLeadname}</td>
            </tr>
            <Divider className="secline" />
          </div>

          <div className="statusdropdwnView">
            <p>Update Status</p>
            <div style={{ width: "35%" }}>
              <FormControl fullWidth>
                <Select
                  className="sourcedfrominput"
                  value={updateStatus !== "" ? updateStatus : getData.status}
                  name="candidateStatus"
                  autoComplete="off"
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "candidateStatus")
                  }
                  style={{ width: "100%", height: "2rem", borderRadius: "4px" }}
                >
                  {candidateStatusValues.map((status) => (
                    <MenuItem
                      className="selectOptions"
                      key={status.id}
                      value={status.internal}
                    >
                      {status.internal}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="updatebutton" style={{ marginLeft: "20%" }}>
              <Button
                className="updatestatussavebtn"
                variant="contained"
                type="submit"
                onClick={HandleSubmit}
                size="small"
              >
                Update
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddApplicantAssociatedJobs;

const findconfiguration = {
  recordperPage: 9,
  currentPage: 1,
  totalRecords: 0,
  limitData: 9,
  isSearchServer: true,
};

const ASAObj = {
  title: " Associate Jobs ",
  description: "",
  bgImage: "",
};
const QAObj = {
  title: "Questions and Answers",
  description: "",
  bgImage: "",
};
